<app-mapping-fields #fields (savedEvent)="saved($event)"></app-mapping-fields>
<div class="form-group row">
    <div class="offset-md-9 col-md-1">
        <button [disabled]="saving" class="btn btn-default" (click)="saving=true;fields.save()">Save mapping</button>
        <span class="text-success">{{saveResult}}</span>
    </div>
</div>
